export default __webpack_public_path__ + "static/media/1.db1e0545.jpg";